const selectCustomStyles = {
  dropdownIndicator: provided => ({
    ...provided,
    color: '#4D5969',
    transform: 'scale(0.8)'
  }),
  indicatorSeparator: provided => ({
    ...provided,
    backgroundColor: 'white'
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#CADEF8' : '#D8E2EF',
    borderWidth: state.isFocused ? '3.8px' : '1px',
    boxShadow: state.isFocused ? `0 0 0 1px #CADEF8` : null,
    '&:hover': {
      borderColor: state.isFocused ? '#CADEF8' : '#D8E2EF'
    }
  })
};

export default selectCustomStyles;
